module.exports = __webpack_public_path__ + "assets/abc206f234efb981ab10e56d745ea725.png";